export default __webpack_public_path__ + "8e2a2c5a43df07747b7b4a2ee9034f9c.png";